<nav class="navbar navbar-expand-md navbar-light scheme-bg-dark p-2">
    <shared-logo [link]="'/projects'"></shared-logo>

    <button class="navbar-toggler bg-light" type="button" (click)="toggleMenu()">
        <span class="navbar-toggler-icon"></span>
    </button>
</nav>

<shared-navbar-menu-mobile [hidden]="!showMenu" (menuClosed)="closeMenu()"></shared-navbar-menu-mobile>